export class ListMicrosoft365SharePointSites200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sharepointSites",
            "baseName": "sharepointSites",
            "type": "Array<Microsoft365SharePointSite>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365SharePointSites200Response.attributeTypeMap;
    }
    constructor() {
    }
}
